<template>
  <section class="grid-container my-5" aria-labelledby="checkout-login">
    <pdl-section-header size="xl">
      <template #content>
        <pdl-heading id="checkout-login" :level="1">{{ $t('login.login') }}</pdl-heading>
      </template>
    </pdl-section-header>
    <div v-if="viewBreakpointIs('small')">
      <pdl-collapse
        accordion
        :default-active="false"
        :model-value="['guest']"
        class="mb-2"
        :header-level="2"
        qaid="checkout-login-collapse"
      >
        <pdl-collapse-item name="guest">
          <template #title>
            <div class="heading heading--sm">{{ $t('guest.checkout') }}</div>
          </template>
          <guest-checkout :options="options" />
        </pdl-collapse-item>
        <pdl-collapse-item name="login">
          <template #title>
            <div class="heading heading--sm">{{ $t('login.title') }}</div>
          </template>
          <user-login :options="options" :error-messages="errorMessages" />
        </pdl-collapse-item>
      </pdl-collapse>
      <div class="text-sm">
        <a :href="withContextPath('/login/')" class="hover:underline">{{ $t('checkout.registration.link') }}</a>
      </div>
    </div>
    <div v-else class="flex my-5">
      <section class="w-1/2 border-r border-gray-10">
        <guest-checkout :options="options" />
      </section>
      <section class="w-1/2">
        <div class="max-w-sm md:ml-2 lg:mx-6">
          <user-login :options="options" :error-messages="errorMessages" />
          <a :href="withContextPath('/login/')" class="hover:underline text-sm block">{{
            $t('checkout.registration.link')
          }}</a>
        </div>
      </section>
    </div>
  </section>
</template>
<script>
import UserLogin from '@/components/containers/my-account/UserLogin';
import GuestCheckout from '@/components/containers/checkout/GuestCheckout';
import {Url} from '@/utils/url';
import {mapState, mapGetters} from 'vuex';
import {PdlSectionHeader, PdlHeading} from '@pedal/pdl-section-header';
import {PdlCollapse, PdlCollapseItem} from '@pedal/pdl-collapse';

export default {
  name: 'LoginCheckoutContainer',
  components: {UserLogin, GuestCheckout, PdlSectionHeader, PdlHeading, PdlCollapse, PdlCollapseItem},
  props: {
    options: {
      type: Object,
      required: true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('viewSize', ['viewBreakpoint']),
    ...mapGetters('viewSize', ['viewBreakpointIs']),
  },
  methods: {
    withContextPath: (url) => Url.withContextPath(url),
  },
};
</script>
